import { useCallback, useContext } from 'react';
import { SipPhoneContext } from '../../../components/SipPhoneProvider';
import { useDispatch, useSelector } from 'react-redux';
import { setCallDirection, setSubscriber } from '../store/actions';
import { callDirections } from '../constants/callDirections';
import { formatPhoneNumber } from '../../../helpers/formatPhoneNumber';
import {
  phoneFieldValueSelector,
  newRequestModalVisibleSelector,
  serviceCompanyValueSelector,
} from '../store/selectors';
import { actions as newRequestAction } from '../../CreateRequest/new-request.actions';

const usePhoneFieldCallHandler = () => {
  const dispatch = useDispatch();

  const { startCall } = useContext(SipPhoneContext);

  const phoneFieldValue = useSelector(phoneFieldValueSelector);
  const newRequestModalVisible = useSelector(newRequestModalVisibleSelector);
  const serviceCompany = useSelector(serviceCompanyValueSelector);

  const handleCall = useCallback(() => {
    if (phoneFieldValue.trim()) {
      const formattedPhoneNum = formatPhoneNumber({
        phoneNumber: phoneFieldValue,
      });

      const subscriber = {
        phone: formatPhoneNumber({
          phoneNumber: phoneFieldValue,
          format: '(xxx) xxx-xx-xx',
          placeholder: 'x',
        }),
      };
      dispatch(setCallDirection(callDirections.outgoing));
      dispatch(setSubscriber(subscriber));
      startCall(formattedPhoneNum);
      if (!newRequestModalVisible) {
        dispatch(newRequestAction.setOwnerData('', formattedPhoneNum));
        dispatch(newRequestAction.applyAddrServiceCompany(serviceCompany?.id));
      }
    }
  }, [
    phoneFieldValue,
    dispatch,
    startCall,
    newRequestModalVisible,
    serviceCompany,
  ]);

  return { handleCall };
};

export default usePhoneFieldCallHandler;
